// ============================================================
// Simulated AI voice calls to a carrier's dispatcher (#66): the
// script is in the carrier's language with a Czech translation;
// the outcome depends on the carrier's usual behaviour. Demo content,
// like the replies in arrivalsData.js. A real call needs a telephony
// provider and a voice model (see the ADR, AI layer).
// ============================================================

import { at } from './arrivalsData';

const OUTCOMES = { D1: 'no-power', D2: 'rescheduled', D3: 'en-route', D4: 'en-route', D5: 'no-answer' };

const SCRIPTS = {
  pl: {
    ask: (l) => `Dzień dobry, tu automatyczny asystent OMYA Pomezí. Czekamy na ${l.plate}, zlecenie ${l.orderId}. Czy auto dziś przyjedzie?`,
    'rescheduled': ['Dzisiaj już nie zdąży, będzie jutro o siódmej.', 'Rozumiem, zapisuję: jutro 7:00. Dziękuję.'],
    'no-power': ['Kierowca ma pauzę, może jechać od piątej trzydzieści.', 'Rozumiem, załadunek jutro od 5:30. Dziękuję.'],
    'en-route': ['Tak, jest w drodze, będzie za około czterdzieści minut.', 'Dziękuję, zapisuję przyjazd za 40 minut.'],
  },
  cs: {
    ask: (l) => `Dobrý den, tady automatický asistent OMYA Pomezí. Čekáme ${l.plate}, zakázka ${l.orderId}. Přijede auto dnes?`,
    'rescheduled': ['Dnes už to nestihne, bude zítra v sedm.', 'Rozumím, zapisuji: zítra 7:00. Děkuji.'],
    'no-power': ['Řidič má přestávku, může jet od půl šesté.', 'Rozumím, nakládka zítra od 5:30. Děkuji.'],
    'en-route': ['Ano, je na cestě, bude tam asi za čtyřicet minut.', 'Děkuji, zapisuji příjezd za 40 minut.'],
  },
};

const CS = SCRIPTS.cs;

const plusMinutes = (min) => new Date(Date.now() + min * 60000).toISOString();

// { lines: [{ who: 'bot' | 'human', text, textCs }], outcome: { state, eta, power, text, textCs } | null }
export function voiceCall(loading, carrier) {
  const outcome = OUTCOMES[carrier.id] || 'en-route';
  const lang = SCRIPTS[carrier.lang] ? carrier.lang : 'cs';
  const s = SCRIPTS[lang];
  const ask = { who: 'bot', text: s.ask(loading), textCs: CS.ask(loading) };
  if (outcome === 'no-answer') return { lines: [ask], outcome: null };

  const [reply, close] = s[outcome];
  const [replyCs, closeCs] = CS[outcome];
  const lines = [ask, { who: 'human', text: reply, textCs: replyCs }, { who: 'bot', text: close, textCs: closeCs }];
  const eta = outcome === 'rescheduled' ? at('07:00', 1) : outcome === 'no-power' ? at('05:30', 1) : plusMinutes(40);
  return {
    lines,
    outcome: { state: outcome, eta, power: outcome === 'no-power' ? '05:30' : null, text: reply, textCs: replyCs },
  };
}
